import { endpoints } from '@mb/api/endpoints';
import { configGlobal } from '@mb/config';

export const getMaterialsByKeyList = async (
  keyList: (string | number)[],
  keyName = 'key.entity_id',
) => {
  try {
    return await fetch(endpoints.materialByKey, {
      method: 'POST',
      body: JSON.stringify({
        siteId: configGlobal.product.siteId,
        extraFields: ['ss_facet_color_filter', 'configurations', 'components'],
        [keyName]: keyList,
        fieldsOnly: true,
      }),
    }).then((res) => res.json());
  } catch (e) {
    return null;
  }
};
